"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const include_1 = require("../node/include");
class TwingTokenParserInclude extends token_parser_1.TwingTokenParser {
    parse(token) {
        let expr = this.parser.getExpressionParser().parseExpression();
        let parsedArguments = this.parseArguments();
        return new include_1.TwingNodeInclude(expr, parsedArguments.variables, parsedArguments.only, parsedArguments.ignoreMissing, token.getLine(), token.getColumn(), this.getTag());
    }
    getTag() {
        return 'include';
    }
    /**
     *
     * @returns {{variables: TwingNodeExpression; only: boolean; ignoreMissing: boolean}}
     */
    parseArguments() {
        let stream = this.parser.getStream();
        let ignoreMissing = false;
        if (stream.nextIf(token_1.TwingToken.NAME_TYPE, 'ignore')) {
            stream.expect(token_1.TwingToken.NAME_TYPE, 'missing');
            ignoreMissing = true;
        }
        let variables = null;
        if (stream.nextIf(token_1.TwingToken.NAME_TYPE, 'with')) {
            variables = this.parser.getExpressionParser().parseExpression();
        }
        let only = false;
        if (stream.nextIf(token_1.TwingToken.NAME_TYPE, 'only')) {
            only = true;
        }
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        return {
            variables: variables,
            only: only,
            ignoreMissing: ignoreMissing
        };
    }
}
exports.TwingTokenParserInclude = TwingTokenParserInclude;
